/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That length is close to the point where sustained attention commonly starts to decline for most people, so it balances covering enough material against diminishing focus. Shorter periods cut into instruction time, while much longer ones tend to lose the class partway through.`)
};

const es_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa duración está cerca del punto en el que la atención sostenida suele empezar a decaer para la mayoría de las personas, así que equilibra cubrir suficiente material con la concentración decreciente. Los períodos más cortos recortan el tiempo de instrucción, mientras que los mucho más largos tienden a perder a la clase a mitad de camino.`)
};

const de_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Länge liegt nahe an dem Punkt, an dem anhaltende Aufmerksamkeit bei den meisten Menschen zu sinken beginnt, und balanciert so genug Lernstoff gegen nachlassenden Fokus. Kürzere Stunden verkürzen die Unterrichtszeit, deutlich längere verlieren die Klasse oft mittendrin.`)
};

const nl_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die lengte ligt dicht bij het punt waarop aanhoudende aandacht voor de meeste mensen gewoonlijk begint af te nemen, dus het balanceert voldoende lesstof behandelen tegen afnemende focus. Kortere periodes gaan ten koste van lestijd, terwijl veel langere periodes de klas vaak halverwege kwijtraken.`)
};

const fr_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette durée est proche du point où l’attention soutenue commence généralement à décliner chez la plupart des gens, ce qui permet d’équilibrer entre couvrir suffisamment de matière et une concentration en baisse. Des périodes plus courtes réduisent le temps d’enseignement, tandis que des périodes bien plus longues ont tendance à perdre la classe en cours de route.`)
};

const it_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella durata è vicina al punto in cui l'attenzione sostenuta inizia comunemente a calare per la maggior parte delle persone, quindi bilancia la necessità di coprire abbastanza materiale con il calo della concentrazione. Periodi più brevi riducono il tempo di insegnamento, mentre quelli molto più lunghi tendono a far perdere l'attenzione della classe a metà.`)
};

const pt_br2_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa duração está perto do ponto em que a atenção sustentada costuma começar a declinar para a maioria das pessoas, equilibrando cobrir conteúdo suficiente com a redução do foco. Períodos mais curtos reduzem o tempo de instrução, enquanto períodos muito mais longos tendem a perder a turma no meio do caminho.`)
};

const pt_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa duração está próxima do ponto em que a atenção sustentada normalmente começa a diminuir para a maioria das pessoas, pelo que equilibra cobrir matéria suficiente contra a diminuição do foco. Períodos mais curtos reduzem o tempo de instrução, enquanto períodos muito mais longos tendem a perder a turma a meio.`)
};

const ja_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この長さは、多くの人にとって持続的な注意力が低下し始めるポイントに近いため、十分な内容をカバーすることと集中力の低下のバランスを取っています。短すぎると授業時間が削られ、長すぎるとクラスが途中で集中を失いがちです。`)
};

const zh_timer_u45m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个时长接近大多数人持续专注力开始下降的临界点，因此在覆盖足够教学内容与专注力衰减之间取得平衡。更短的课时会压缩教学时间，而更长的课时往往会在中途失去学生的注意力。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_faq3_a", locale)
	if (locale === "en") return en_timer_u45m_faq3_a(inputs)
	if (locale === "es") return es_timer_u45m_faq3_a(inputs)
	if (locale === "de") return de_timer_u45m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u45m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u45m_faq3_a(inputs)
	if (locale === "it") return it_timer_u45m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u45m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u45m_faq3_a(inputs)
	return zh_timer_u45m_faq3_a(inputs)
};